import axios from './../../config/axios';

export function getItems(params) {
    return axios().get(`/stock-journal/item`, { params })
}

export function getItem({id}) {
    return axios().get(`/stock-journal/item/${id}`)
}

export function search(query) {
    return axios().get(`/stock-journal/item-search`, { params: {
        search: query
    } });
}

function barcode(query) {
    return axios().get(`/stock-journal/item-barcode`, { params: {
        barcode: query
    } });
}

export default {
    search,
    barcode,
    getItem,
    getItems
}